import { Component } from "react";
import * as React from "react";
import { Link } from "react-router-dom";

class Header extends Component<any, any> {

	public render() {
		return (
			<header id="page-header">
				<div className="content-header">
					<div className="d-flex align-items-center">
						<Link className="link-fx font-size-lg font-w600 text-white" to="/">
							<span className="text-white">Craftmania.cz Stats</span>
						</Link>
					</div>
				</div>
			</header>
		);
	}

}

export default Header;
